import Overview from "./Overview"
import GlobalInsights from "./GlobalInsights/"
import CountryInsights from "./CountryInsights/"
import Factors from "./Factors/"
import About from "./About/"
import Insights from "./Insights/"

export const routes = [
  {
    url: "/",
    route: "/",
    text: "Overview",
    component: Overview,
    hide: true,
    // Shows its headline while the data loads, and draws the map once it has.
    // Other pages show "Loading..." until then.
    rendersBeforeData: true,
  },
  {
    url: "/global",
    route: "/global/:opt1?/:opt2?/:opt3?/:opt4?",
    text: "Rankings",
    component: GlobalInsights,
    hasInsights: true,
  },
  {
    url: "/country",
    route: "/country/:opt1?/:opt2?/:opt3?",
    text: "Countries",
    component: CountryInsights,
    hasInsights: true,
  },
  {
    url: "/factors",
    route: "/factors/:opt1?/:opt2?/:opt3?",
    text: "Factors",
    component: Factors,
    hasInsights: true,
  },
  {
    url: "/insights",
    route: "/insights",
    text: "Insights",
    component: Insights,
    hasInsights: false,
  },
  {
    url: "/about",
    route: "/about",
    text: "About",
    component: About,
    hasInsights: false,
  },
]

export const routesReversed = routes.slice().reverse()
